module.exports = __webpack_public_path__ + "static/media/collagen360ºElixir.526fe523.png";